export default {
  hasBoats: 'Båtuthyrning',
  fishSpecies: 'Fisken',
  fishingMethods: 'Fisketyper',
  amenities: 'Bekvämligheter',
};
